import { useFormikContext } from 'formik';
import React from 'react';
import {
  SparkDropdown,
  SparkFormTaggedAutoComplete,
} from 'sharedComponents/SparkForm';
import type { DropdownOption } from 'types/common/DropdownOption';
import type { PrivacyInfoFormValues } from './PrivacyInfoForm';

type PrivacyInfoCategoryContentProps = { categoriesOptions: DropdownOption[] };

function PrivacyInfoCategoryContent({
  categoriesOptions,
}: PrivacyInfoCategoryContentProps) {
  const { values } = useFormikContext<PrivacyInfoFormValues>();

  const subCategoryOptions = React.useMemo(() => {
    const mainCategoryID = values.mainCategoryID;
    return categoriesOptions.filter(
      (option) => option.value !== mainCategoryID
    );
  }, [categoriesOptions, values]);

  return (
    <>
      <SparkDropdown label='Main Category' name='mainCategoryID' size={12}>
        {categoriesOptions}
      </SparkDropdown>
      <SparkFormTaggedAutoComplete
        label='Subcategories'
        name='subCategories'
        placeholder='Select up to 3 Subcategories'
        options={subCategoryOptions}
      />
    </>
  );
}

export default PrivacyInfoCategoryContent;
